export default {
  meta: {
    title: '订单中心',
    url: '/intelligent/order',
    parentPath: ['/intelligent'],
    breadcrumbs: {
      path: ['/intelligent/order'],
      name: ['订单中心'],
    },
  }
};
